// Blocks Service - API calls for blocks management
import api from './api';

const blocksService = {
  // Get all blocks
  getAllBlocks: async () => {
    return api.request('/blocks');
  },

  // Get single block with details
  getBlock: async (blockId) => {
    return api.request(`/blocks/${blockId}`);
  },

  // Create new block
  createBlock: async (blockData) => {
    return api.request('/blocks', {
      method: 'POST',
      body: blockData
    });
  },

  // Update block
  updateBlock: async (blockId, blockData) => {
    return api.request(`/blocks/${blockId}`, {
      method: 'PUT',
      body: blockData
    });
  },

  // Delete block
  deleteBlock: async (blockId) => {
    return api.request(`/blocks/${blockId}`, {
      method: 'DELETE'
    });
  },

  // Assign classes to block
  assignClasses: async (blockId, classes) => {
    return api.request(`/blocks/${blockId}/classes`, {
      method: 'POST',
      body: { classes }
    });
  },

  // Remove class from block
  removeClass: async (blockId, assignmentId) => {
    return api.request(`/blocks/${blockId}/classes/${assignmentId}`, {
      method: 'DELETE'
    });
  },

  // Enroll student in block
  enrollStudent: async (blockId, studentId, paymentPlan, notes) => {
    return api.request(`/blocks/${blockId}/enrollments`, {
      method: 'POST',
      body: { studentId, paymentPlan, notes }
    });
  },

  // Update enrollment
  updateEnrollment: async (blockId, enrollmentId, updates) => {
    return api.request(`/blocks/${blockId}/enrollments/${enrollmentId}`, {
      method: 'PUT',
      body: updates
    });
  }
};

export default blocksService;
